import React, {useState, useEffect} from 'react';
import {NavBar, Icon, Toast, ActivityIndicator} from 'antd-mobile';
import {Link} from 'react-router-dom';
import {Flex, WhiteSpace, WingBlank} from 'antd-mobile';
import dal from '../data/DAL';
import RenewLog from '../models/RenewLog'
import FlexItem from "antd-mobile/lib/flex/FlexItem";
// import CopyToClipboard from "react-copy-to-clipboard";
let CopyToClipboard = require('react-copy-to-clipboard');
/**
 * 充值记录页面
 */
const PayHistory: React.FC = () => {

    const [renewLogs, setRenewLogs] = useState(new Array<RenewLog>())
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        setAnimating(true);
        dal.fetchRenewLog().then(() => {
            setAnimating(false);
            setRenewLogs(dal.state.renewLogs)
        })
    }, [])

    const onCopy = () => {
       Toast.success('已复制到剪切板');
    }
    return (
        <div>
            <NavBar
                mode="light"
                //icon={<Link to={"/charge-plan"}><Icon color={'#666666'} size={'lg'} type="left"/></Link>}
                icon={<Icon color={'#666666'} size={'lg'} type="left"/>}
                onLeftClick={() => {
                    window.history.back()
                }}
                rightContent={[]}>
                充值记录
            </NavBar>
            <WhiteSpace size="lg"/>
            <WingBlank>
                <Flex style={{flexDirection: 'column'}}>
                    {renewLogs.map(r => {
                        return (
                            <FlexItem className={"renew-log-item"}>
                                <CopyToClipboard text={r.paymentId} onCopy={onCopy}>
                                    <div style={{marginBottom: '1em', color: 'grey'}}>
                                        订单号：{r.paymentId}
                                    </div>
                                </CopyToClipboard>

                                <div style={{float: 'left'}}>
                                    {r.desc}:获取{r.duration}天，花费{r.cost}元
                                </div>
                                <div style={{float: 'right'}}>
                                    {r.createTime}
                                </div>
                            </FlexItem>
                        )
                    })}

                </Flex>
                <p hidden={animating || renewLogs.length !== 0} style={{textAlign: 'center'}}>暂无充值记录</p>
            </WingBlank>
            <ActivityIndicator toast text="正在加载" animating={animating}/>
        </div>
    );
}

export default PayHistory
